export default __webpack_public_path__ + "static/media/chevrolet.eb9837d8.svg";